import gradeApi from '~/plugins/axios.grades.plugin';

export default {
  fetchVariablesForAverageWithBlockOrigin({ courseId, categoryId }) {
    return gradeApi.custAxios().get(`course/${courseId}/category/${categoryId}/average/formula/variables`);
  },
  fetchAverageFormula({ courseId, categoryId }) {
    return gradeApi.custAxios().get(`course/${courseId}/category/${categoryId}/average/formula`);
  },
  fetchResultFormula({ courseId }) {
    return gradeApi.custAxios().get(`course/${courseId}/final/formula/result`);
  },
  fetchResultFormulaVariables({ courseId }) {
    return gradeApi.custAxios().get(`course/${courseId}/final/formula/result/variables`);
  },
  fetchFinalFormula({ courseId }) {
    return gradeApi.custAxios().get(`course/${courseId}/final/formula`);
  },
  upsertAverageFormula(courseId, categoryId, value) {
    return gradeApi.custAxios().put(`course/${courseId}/category/${categoryId}/average/formula`, value);
  },
  upsertFinalFormula(courseId, value) {
    return gradeApi.custAxios().put(`course/${courseId}/final/formula`, value);
  },
  upsertResultFormula(courseId, value) {
    return gradeApi.custAxios().put(`course/${courseId}/final/formula/result`, value);
  },
  patchCalculateEnrollmentAverageGrade(courseId, categoryId, enrollmentId) {
    return gradeApi.custAxios().patch(`course/${courseId}/category/${categoryId}/enrollment/${enrollmentId}/average/formula/calculate`);
  },
  patchCalculateEnrollmentFinalGrade(courseId, enrollmentId) {
    return gradeApi.custAxios().patch(`course/${courseId}/enrollment/${enrollmentId}/final/formula/calculate`);
  },
  patchCalculateEnrollmentModule(courseId, categoryId, gradeBookId, enrollmentId) {
    return gradeApi.custAxios().patch(`course/${courseId}/categories/${categoryId}/books/${gradeBookId}/enrollment/${enrollmentId}/calculate`);
  },
  patchCalculateEnrollmentResult(courseId, enrollmentId) {
    return gradeApi.custAxios().patch(`course/${courseId}/enrollment/${enrollmentId}/final/formula/result/calculate`);
  },
  patchCalculateGrade(courseId) {
    return gradeApi.custAxios().patch(`course/${courseId}/final/formula/result/calculate`);
  }
};
